
import {defineComponent} from 'vue';
import ScreenWrapper from "@/components/elements/ScreenWrapper.vue";
import {useState} from "@/hooks/state";
import {ScreenConfigIntro} from "@/Screens.types";

const state = useState();
export default defineComponent({
  components: {
    ScreenWrapper
  },
  props: {
    msg: String,
    goTo: Function,
    config: Object as () => ScreenConfigIntro,
  },

  setup() {
    return {
      state
    }
  },
  data() {
    return {
      screen: this.config.screenId,
      showNicknameModal: false
    }
  },

  mounted() {
    this.state.resetState();
  },

  methods: {
    next() {
      this.goTo(this.config.screenNext)
    },

    start() {
      // Open modal for nicname
      this.showNicknameModal = true;
    }
  }
});
